let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("BbB4M")).then(() => parcelRequire('JSoWM'));